import type { DeepReadonly } from "@atoms/atom-types";

/**
 * Deep freezes an object and all nested objects
 */
export function deepFreeze<T>(obj: T): DeepReadonly<T> {
  if (obj === null || typeof obj !== "object") {
    return obj as DeepReadonly<T>;
  }

  Object.getOwnPropertyNames(obj).forEach((prop) => {
    const value = (obj as Record<string, unknown>)[prop];
    if (value !== null && typeof value === "object") {
      deepFreeze(value);
    }
  });

  return Object.freeze(obj) as DeepReadonly<T>;
}
